import $ from "jquery";
import "jqtree/tree.jquery";
import PageItem from './PageItem.vue';
import { createApp } from 'vue';

$('[data-component="page-struct"]').each(function() {
    const csrfToken = $(this).data('csrfToken');
    $(this).tree({
        data: $(this).data('tree'),
        dragAndDrop: true,
        autoOpen: true,
        closedIcon: $('<i class="material-icons">chevron_right</i>'),
        openedIcon: $('<i class="material-icons">expand_more</i>'),
        onCanMove: node => true,
        onCanMoveTo: (moved_node, target_node, position) => true,
        onIsMoveHandle: function($element) {
            return ($element.is('.jqtree-title .drag-handler'));
        },
        onCreateLi: (node, $li) => {
            const $title = $li.find('.jqtree-title');
            createApp(PageItem, { node, csrfToken }).mount($title[0]);
        }
    }).on('tree.move', async e => {
        e.preventDefault();
        const formData = new FormData;
        formData.append('node', e.move_info.moved_node.id);
        formData.append('position', e.move_info.position);
        formData.append('previousParent', e.move_info.previous_parent.id);
        formData.append('target', e.move_info.target_node.id);
        formData.append('_token', csrfToken);
        const response = await fetch($(this).data('updateUrl'), {
            'method': 'POST',
            'body': formData
        });

        if (response.redirected) {
            window.location.href = response.url;
        }

        const responseData = await response.json();
        if (responseData.status === 'OK') {
            e.move_info.do_move();
        }

        $('.jqtree-tree').find('li.jqtree_common div.jqtree-element').each(function(index) {
            if (index === 0) {
                if ($(this).find('.first-container .home-icon').length === 0) {
                    $('<i class="material-icons home-icon">home</i>').insertAfter($(this).find('.first-container .drag-handler'));
                }
                $(this).find('.first-container .page-url').text('(/)');
                $(this).find('.second-container .copy-url').attr('data-copy', '/');
                $(this).find('.second-container .go-to-url').attr('href', '/');
                $(this).find('.dropdown .delete-page').addClass('d-none');
            } else {
                const originalUrl = $(this).find('.first-container').attr('data-original-url');
                $(this).find('.home-icon').remove();
                $(this).find('.first-container .page-url').text(`(${originalUrl})`);
                $(this).find('.second-container .copy-url').attr('data-copy', originalUrl);
                $(this).find('.second-container .go-to-url').attr('href', originalUrl);
                $(this).find('.dropdown .delete-page').removeClass('d-none');
            }
        })
    })
});

$('body').on('click', '.page-menu', function(e) {
    e.preventDefault();
});

$('#pages_filter_search').on('click', function(e) {
    e.preventDefault();
    const search = $('#pages-title-filter').val();
    const pageType = $('#pages-type-filter').val();

    highlightText(search, $(".jqtree-tree .jqtree-title .first-container .page-title"));
    highlightText(pageType, $(".jqtree-tree .jqtree-title .second-container .page-type"));
});

$('#pages_filter_clear').on('click', function() {
    $('#pages-title-filter').val('');
    $('#pages-type-filter').val(null).trigger('change');

    $('#pages_filter_search').trigger('click');
});

function highlightText(search, $element) {
    const replaceD = "<span class='highlight'>" + search + "</span>";
    $element.each(function() {
        let text = $(this).text();
        text = text.replaceAll(search, replaceD);
        $(this).html(text);
    });
}
